import React from 'react';

import { Badge, Box, IndexTable, InlineStack, Select, Text } from '@shopify/polaris';

const INHERIT = '';
const CODE_COLUMN_WIDTH = '320px';
const SOURCE_COLUMN_WIDTH = '120px';

const HEADINGS = [
    { title: 'Shopify category' },
    { title: 'Source' },
    { title: 'Planet article code', alignment: 'end' },
];

function sourceBadge(source) {
    if (source === 'custom') return <Badge tone="attention">Custom</Badge>;
    if (source === 'default') return <Badge tone="info">Default</Badge>;

    return <Badge>Not mapped</Badge>;
}

/**
 * Rows of Shopify categories against the Planet article code each one reports.
 *
 * Each row needs a `label` already formatted by the caller, since a top-level category
 * shows its name while an exception shows its path.
 */
function CategoryMappingTable({ rows, codes, savingGid, onChange, resourceName }) {
    function codeOptions(row) {
        const inheritLabel = row.default_code ? `Use default (${row.default_code})` : 'No article code';

        return [{ value: INHERIT, label: inheritLabel }, ...codes];
    }

    return (
        <IndexTable resourceName={resourceName} itemCount={rows.length} headings={HEADINGS} selectable={false}>
            {rows.map((row, index) => (
                // Both trailing columns are fixed width so nothing reflows when a row flips
                // between Default and Custom; the flexible name column absorbs the slack and
                // keeps the code column pinned to the right edge.
                <IndexTable.Row id={row.gid} key={row.gid} position={index}>
                    <IndexTable.Cell>
                        {/* breakWord lets long breadcrumb paths wrap. Without it their min-content
                            width pushes the table past the card and IndexTable adds a scrollbar. */}
                        <Text variant="bodyMd" fontWeight="semibold" as="span" breakWord>
                            {row.label}
                        </Text>
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                        <Box width={SOURCE_COLUMN_WIDTH}>{sourceBadge(row.source)}</Box>
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                        <InlineStack align="end">
                            <Box width={CODE_COLUMN_WIDTH}>
                                <Select
                                    label="Article code"
                                    labelHidden
                                    options={codeOptions(row)}
                                    value={row.source === 'custom' ? row.code : INHERIT}
                                    disabled={savingGid === row.gid}
                                    onChange={(value) => onChange(row.gid, value)}
                                />
                            </Box>
                        </InlineStack>
                    </IndexTable.Cell>
                </IndexTable.Row>
            ))}
        </IndexTable>
    );
}

export default CategoryMappingTable;
